import { render, staticRenderFns } from "./AddSharedDashboard.vue?vue&type=template&id=09a5ee54&"
import script from "./AddSharedDashboard.vue?vue&type=script&lang=js&"
export * from "./AddSharedDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AddSharedDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports